// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-1aWzF";
var _3 = "paper-2ycwG";
export { _1 as "__esModule", _2 as "button", _3 as "paper" }
export default { "__esModule": _1, "button": _2, "paper": _3 }
